module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "become-an-affiliate"
  }, [_c('div', {
    attrs: {
      "id": "content"
    }
  }, [_c('p', {
    staticClass: "explain"
  }, [_vm._v(_vm._s(_vm.$t('explain')))]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "reward-lists"
    }
  }, [_c('p', {
    staticClass: "reward-rules-title"
  }, [_vm._v(_vm._s(_vm.$t('rewardRules')))]), _vm._v(" "), _vm._l((_vm.$t('rulesList')), function(rule, index) {
    return _c('p', {
      key: index,
      staticClass: "rules-list"
    }, [_c('span', {
      staticClass: "index"
    }, [_vm._v(_vm._s(index + 1))]), _vm._v("\n        " + _vm._s(rule) + "\n      ")])
  })], 2), _vm._v(" "), _c('div', {
    attrs: {
      "id": "affiliate-form"
    }
  }, [(_vm.alreadyApply) ? _c('p', {
    staticClass: "error-notice"
  }, [_vm._v("\n        *\n        "), (_vm.commissionApplyStatus === 'pending') ? _c('span', [_vm._v(_vm._s(_vm.$t('notice.pending')))]) : _vm._e(), _vm._v(" "), (_vm.commissionApplyStatus === 'cancelled') ? _c('span', [_vm._v(_vm._s(_vm.$t('notice.cancelled')))]) : _vm._e(), _vm._v(" "), (_vm.commissionApplyStatus === 'complete') ? _c('span', [_vm._v(_vm._s(_vm.$t('notice.complete')))]) : _vm._e(), _vm._v("\n        iplexservice@gmail.com\n      ")]) : _vm._e(), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.user.id === 0),
      expression: "user.id === 0"
    }],
    staticClass: "error-notice"
  }, [_vm._v("* " + _vm._s(_vm.$t('notice.notLogin')))]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-6"
  }, [_c('p', {
    staticClass: "input-name"
  }, [_vm._v("* " + _vm._s(_vm.$t('promotionPlatform')))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.platform),
      expression: "platform"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: {
      'danger-border': _vm.platformError
    },
    attrs: {
      "autocomplete": "off",
      "type": "text",
      "name": "promotionPlatform",
      "disabled": _vm.canNotApply
    },
    domProps: {
      "value": (_vm.platform)
    },
    on: {
      "focus": function($event) {
        _vm.platformBlur = false
      },
      "blur": function($event) {
        _vm.platformBlur = true
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.platform = $event.target.value
      }
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "error-info"
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.platformError),
      expression: "platformError"
    }]
  }, [_vm._v(_vm._s(_vm.errors.first('promotionPlatform')))])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-6"
  }, [_c('p', {
    staticClass: "input-name"
  }, [_vm._v("* " + _vm._s(_vm.$t('promotionMethod')))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.type),
      expression: "type"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: {
      'danger-border': _vm.typeError
    },
    attrs: {
      "autocomplete": "off",
      "type": "text",
      "name": "promotionMethod",
      "disabled": _vm.canNotApply
    },
    domProps: {
      "value": (_vm.type)
    },
    on: {
      "focus": function($event) {
        _vm.typeBlur = false
      },
      "blur": function($event) {
        _vm.typeBlur = true
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.type = $event.target.value
      }
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "error-info"
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.typeError),
      expression: "typeError"
    }]
  }, [_vm._v(_vm._s(_vm.errors.first('promotionMethod')))])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-6"
  }, [_c('p', {
    staticClass: "input-name"
  }, [_vm._v("* " + _vm._s(_vm.$t('companyName')))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.companyName),
      expression: "companyName"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: {
      'danger-border': _vm.companyNameError
    },
    attrs: {
      "autocomplete": "off",
      "type": "text",
      "name": "companyName",
      "disabled": _vm.canNotApply
    },
    domProps: {
      "value": (_vm.companyName)
    },
    on: {
      "focus": function($event) {
        _vm.companyNameBlur = false
      },
      "blur": function($event) {
        _vm.companyNameBlur = true
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.companyName = $event.target.value
      }
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "error-info"
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.companyNameError),
      expression: "companyNameError"
    }]
  }, [_vm._v(_vm._s(_vm.errors.first('companyName')))])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-6"
  }, [_c('p', {
    staticClass: "input-name"
  }, [_vm._v(_vm._s(_vm.$t('officialSite')))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.address),
      expression: "address"
    }],
    attrs: {
      "autocomplete": "off",
      "type": "text",
      "name": "officialSite",
      "disabled": _vm.canNotApply
    },
    domProps: {
      "value": (_vm.address)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.address = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "explanation-box"
  }, [_c('p', {
    staticClass: "input-name"
  }, [_vm._v(_vm._s(_vm.$t('explanation')))]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.remarks),
      expression: "remarks"
    }],
    attrs: {
      "name": "explanation",
      "disabled": _vm.canNotApply
    },
    domProps: {
      "value": (_vm.remarks)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.remarks = $event.target.value
      }
    }
  }), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "notice"
    }
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showNotice),
      expression: "showNotice"
    }],
    staticClass: "please-agree-policy"
  }, [_vm._v(_vm._s(_vm.$t('pleaseAgreePolicy')))])])], 1), _vm._v(" "), _c('p', {
    class: ['affiliate-policy-box text-center', {
      'agree-policy': _vm.agreePolicy
    }]
  }, [(_vm.canNotApply) ? _c('span', {
    staticClass: "circle-span disabled-span"
  }) : _c('span', {
    staticClass: "circle-span",
    on: {
      "click": _vm.changeAgreePolicyStatus
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": "/static/img/affiliate/agree_policy_2x.png",
      "alt": "agree affiliate policy"
    },
    on: {
      "click": _vm.changeAgreePolicyStatus
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('submitMeans')))]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "affiliate-policy"
    }
  }, [_vm._v(_vm._s(_vm.$t('affiliatePolicy')))])], 1), _vm._v(" "), _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.loading),
      expression: "!loading"
    }],
    class: ['gradient-border-btn', {
      'disabled-btn': _vm.canNotApply
    }],
    on: {
      "click": _vm.becomeAnAffiliate
    }
  }, [_c('span', {
    staticClass: "fill-bg"
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('becomeAffiliate')))])]), _vm._v(" "), _c('spinner', {
    staticClass: "spinner-component",
    attrs: {
      "show": _vm.loading
    }
  })], 1)]), _vm._v(" "), (_vm.applySuccess) ? _c('become-affiliate-success-modal') : _vm._e(), _vm._v(" "), (_vm.alreadyApply) ? _c('commission-apply-status-modal') : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-6159e3f6!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/becomeAnAffiliate/Index.vue
// module id = 1334
// module chunks = 1